import { render } from "./Company-page.vue?vue&type=template&id=d17df35a&scoped=true"
import script from "./Company-page.vue?vue&type=script&lang=js"
export * from "./Company-page.vue?vue&type=script&lang=js"

import "./Company-page.vue?vue&type=style&index=0&id=d17df35a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d17df35a"]])

export default __exports__